module.exports = __webpack_public_path__ + "static/precshool-curr-b48c856355106c5362d9b8494c7dd0d1.jpg";